import { CategoryEnum, ActionsEnum } from '@academica-box/analytics/events/index'
import type {
  LandingClickButton,
  LandingClickFormButton,
  LandingClickSubscribeButton,
  LandingSuccessfulSubmit,
  LandingUnsuccessfulSubmit,
  LandingSuccessfulPayment,
  LandingUnsuccessfulPayment,
  LandingShowStartScreen,
  LandingClickStartScreen,
  LandingShowBlockWillLearn,
  LandingClickBlockWillLearn,
  LandingShowBlockContent,
  LandingClickBlockContent,
  LandingShowBlockAuthors,
  LandingClickBlockAuthors,
  LandingShowBlockCertificate,
  LandingClickBlockCertificate,
  LandingClickBlockCertificateButton,
  LandingShowCourseCard,
  LandingClickCourseCard,
  LandingShowCard,
  LandingClickCard,
  LandingSuccessfulSubscribe
} from '@academica-box/analytics/events/landing'

export const sendLandingClickButton = (context: LandingClickButton['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.click_button,
    context,
  })
}

export const sendLandingClickFormButton = (context: LandingClickFormButton['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.click_form_button,
    context,
  })
}

export const sendLandingClickSubscribeButton = (context: LandingClickSubscribeButton['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.click_subscribe_button,
    context,
  })
}

export const sendLandingSuccessfulSubmit = (context: LandingSuccessfulSubmit['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.successful_submit,
    context,
  })
}

export const sendLandingUnsuccessfulSubmit = (context: LandingUnsuccessfulSubmit['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.unsuccessful_submit,
    context,
  })
}

export const sendLandingSuccessfulSubscribe = (context: LandingSuccessfulSubscribe['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.successful_subscribe,
    context,
  })
}

export const sendLandingSuccessfulPayment = (context: LandingSuccessfulPayment['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.successful_payment,
    context,
  })
}

export const sendLandingUnsuccessfulPayment = (context: LandingUnsuccessfulPayment['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.unsuccessful_payment,
    context,
  })
}

export const sendLandingShowStartScreen = (context: LandingShowStartScreen['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.show_start_screen,
    context,
  })
}

export const sendLandingClickStartScreen = (context: LandingClickStartScreen['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.click_start_screen,
    context,
  })
}

export const sendLandingShowBlockWillLearn = (context: LandingShowBlockWillLearn['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.show_block_will_learn,
    context,
  })
}

export const sendLandingClickBlockWillLearn = (context: LandingClickBlockWillLearn['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.click_block_will_learn,
    context,
  })
}

export const sendLandingShowBlockContent = (context: LandingShowBlockContent['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.show_block_content,
    context,
  })
}

export const sendLandingClickBlockContent = (context: LandingClickBlockContent['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.click_block_content,
    context,
  })
}

export const sendLandingShowBlockAuthors = (context: LandingShowBlockAuthors['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.show_block_authors,
    context,
  })
}

export const sendLandingClickBlockAuthors = (context: LandingClickBlockAuthors['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.click_block_authors,
    context,
  })
}

export const sendLandingShowBlockCertificate = (context: LandingShowBlockCertificate['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.show_block_certificate,
    context,
  })
}

export const sendLandingClickBlockCertificate = (context: LandingClickBlockCertificate['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.click_block_certificate,
    context,
  })
}

export const sendLandingClickBlockCertificateButton = (context: LandingClickBlockCertificateButton['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.click_block_certificate_button,
    context,
  })
}

export const sendLandingShowCourseCard = (context: LandingShowCourseCard['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.show_course_card,
    context,
  })
}

export const sendLandingClickCourseCard = (context: LandingClickCourseCard['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.click_course_card,
    context,
  })
}

export const sendLandingShowCard = (context: LandingShowCard['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.show_card,
    context,
  })
}

export const sendLandingClickCard = (context: LandingClickCard['context']) => {
  const { $analytics } = useNuxtApp()
  $analytics?.push({
    category: CategoryEnum.Landing,
    action: ActionsEnum.click_card,
    context,
  })
}
